export default "__VITE_ASSET__BpLsOVYW__"